import { render, staticRenderFns } from "./PopupPage.vue?vue&type=template&id=2f3a5af8&scoped=true&"
import script from "./PopupPage.vue?vue&type=script&lang=ts&"
export * from "./PopupPage.vue?vue&type=script&lang=ts&"
import style0 from "./PopupPage.vue?vue&type=style&index=0&id=2f3a5af8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a5af8",
  null
  
)

export default component.exports